import {
	AEMComponentMapper,
	AEMComponentType,
	AEMOptions
} from "@AEM/models/AEMPage.model"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import { AEMPage } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"
import { createDefaultMapper } from "@AEM/AEMContentMapper"
export const useAEMComponentData = (
	page: AEMPageType,
	componentType: AEMComponentMapper,
	options?: AEMOptions,
	selectorId?: string
) => {
	const { data, isLoading, error, refetch } = useAEMContent(
		page,
		{
			...options,
			mapper: createDefaultMapper()
		},
		options?.enabled !== false
	) as UseQueryResult<AEMPage>
	const componentData = data?.items?.[0]?.components?.find(
		(component: AEMComponentType) =>
			component?.type === componentType &&
			(options?.uniqueId
				? component?.uniqueId === options?.uniqueId
				: selectorId
					? component?.uniqueId === selectorId
					: true)
	)

	return { componentData, isLoading, error, refetch }
}
